import { DocumentListSection } from "../../../../../components/Proposal&Contracts/DocumentListSection.tsx"

export const defaultInclusions = [
  "Labor, rough materials, equipment, and transportation.",
  "All tools and construction equipment required to complete the project.",
  "Taxes and site cleanup.",
  "Project management and coordination with subcontractors."
]

export function ProposalInclusionsSection() {
  return (
    <DocumentListSection
      title="Inclusions"
      name="inclusions"
      // defaultItems={defaultInclusions}
      // infoFieldName={["inclusionsInfo"]}
      // infoPlaceholder="This proposal includes"
      itemPlaceholder="Inclusion item"
      addButtonText="Inclusion"
    />
  )
}
